import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useGlobalFilter, useTable } from "react-table";
import { UserApiCalls } from "../../apis/UserApiCalls";
import { ReactComponent as NoResult } from "../../images/no_result.svg";
import {
    CREATE_QUESTION_PROFILE_MODAL_INPUT,
    MODAL_CANCEL_TEXT,
    MODAL_DELETE_TEXT,
    NO_RESULTS_FOUND,
    QUESTION_PROFILE_MESSAGE,
    DELETE_QUE_BANK_TITLE,
    QUES_BANK_NAME,
    TEXTBOX,
    TOTAL_QUES_BANK
} from "../../utils/constants";
import styles from "./QuestionProfiles.module.css";
import YuJaGeneralAlert from "./YuJaGeneralAlert";

export default React.memo(QuestionProfileTable);
function QuestionProfileTable({
                                  data = [],
                                  columns = [],
                                  pageIdx=0,
                                  getQuestionProfiles,
                                  keys,
                                  selectedQuestionProfile,
                                  setSelectedQuestionProfile,
                                  setModalShow,
                                  handleKeyClick,
                                  globalFilterObj = {},
                                  buttonStyle,
}) {
    const history = useHistory();
    const { deleteQuestionProfile} = UserApiCalls(); 
    const [alertShow, setAlertShow] = useState(false); 
    const [actionshow, setActionShow] = useState(false); 

    // const [selectedIndex, setSelectedIndex] = useState(null); 


    const filterCustomize = (rows, columnIds, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase() : "";
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.title && values.title.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            return false;
        });
    };


    useEffect(() => {
        setGlobalFilter(globalFilterObj);
    }, [data, globalFilterObj]); 


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows, 
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        globalFilter: filterCustomize,
    } , useGlobalFilter);

    function formatNumberWithLeadingZeros(number, desiredLength) {
        return number.toString().padStart(desiredLength, '0');
      }

      const onDelete = async (questionProfileId) => {
        setSelectedQuestionProfile(questionProfileId); 
        setAlertShow(true); 
        setActionShow(false);
    }

    const onEdit = (questionProfileId) => {
        setModalShow(false);
        history.push({ pathname: "/questions/edit/" + questionProfileId });
    }

    const alertConfig = {
        title: DELETE_QUE_BANK_TITLE,
        okText: MODAL_DELETE_TEXT,
        cancelText: MODAL_CANCEL_TEXT, 
        submit: async () => {
          setAlertShow(false);
          const res = await deleteQuestionProfile(selectedQuestionProfile);
          if (res.success) {
            getQuestionProfiles();
            }
        },
        close:  async () => {
          setAlertShow(false);
        }, 
    };

    const closeAction = () => {
        if(actionshow) {
            setActionShow(false);
        }
    }


    return (
        <>
            <YuJaGeneralAlert
                show={alertShow}
                setModalShow={setAlertShow}
                content={QUESTION_PROFILE_MESSAGE}
                config={alertConfig}
                AlertType={MODAL_DELETE_TEXT}
            />
            <div className={styles.tableContainer} style={{border: "0.25px solid #646464", borderRadius: "5px", marginTop: "20px"}} onClick={closeAction}>
                <Table hover {...getTableProps({style: {minHeight: rows.length ===0 ? "100%" : "", marginBottom: "0px"}})}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th  {...column.getHeaderProps({
                                        style: {
                                            width: column.width,
                                            minWidth: column.minWidth,
                                            ...(column.render('Header') === CREATE_QUESTION_PROFILE_MODAL_INPUT
                                            ? {
                                                  textAlign: "left", 
                                                  paddingLeft: "10px"
                                              }
                                            : {
                                              }),
                                        }
                                    })}>
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody className={styles.tablebody} {...getTableBodyProps({style: {overflowY: "auto", height: "100%", marginBottom: "0px"}})}>
                        {rows.length!== 0 ? rows.map((row) => {
                            prepareRow(row)
                            // console.log(row)
                            return (
                                <tr tabIndex={0} aria-label={QUES_BANK_NAME + row.original.title} role={TEXTBOX} {...row.getRowProps()} onClick={() => handleKeyClick(data[row.index], row.index)} style={{cursor: "pointer"}}>
                                    { row.cells.map((cell, index) => {
                                        if (cell.column.Header === 'Questions')  {
                                            return (
                                                <td  {...cell.getCellProps({style: {wordBreak: 'break-word', fontSize: "16px",  color: "#000000"}})}>
                                                    {formatNumberWithLeadingZeros(cell.value.length, 2)}
                                                </td>
                                            );
                                        } else if (cell.column.Header === 'Question Bank Name') {
                                            return (
                                                <td  {...cell.getCellProps({style: {wordBreak: 'break-word', fontSize: "16px",  color: "#000000", textAlign: "left"}} )}
                                                     title={cell.value?.length > 30 ? cell.value : ""}
                                                >
                                                    {cell.value?.length > 30 ? `${cell.value.slice(0, 30)}...` : cell.value}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            )
                        }
                        ) : <>
                        <td align="center" colSpan="2" className={styles.tableNoPadding}> <div style={{width: "100%", height: "100%"}}> <NoResult/> <div style={{marginTop: "20px", fontSize: 20, lineHeight: 1.4, fontWeight: 600}}>{NO_RESULTS_FOUND}</div> </div></td>
                    </>}
                    </tbody>
                    </Table>
            </div>
        </>
    );
}